export default __webpack_public_path__ + "static/1577-38fc53c29a352407909bf26240926e98.gif";